import { render, staticRenderFns } from "./ProductIdListForm.vue?vue&type=template&id=7b2057fd&scoped=true"
import script from "./ProductIdListForm.vue?vue&type=script&lang=js"
export * from "./ProductIdListForm.vue?vue&type=script&lang=js"
import style0 from "./ProductIdListForm.vue?vue&type=style&index=0&id=7b2057fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2057fd",
  null
  
)

export default component.exports